import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_USERS = "users";
const BASE_URL = "/api/users";

const UserQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const MEMBER_EMPTY = {

    memberNumber:"",
    Sector:"",
    username:"",
    password:"",
    role:"",
    email:"",
    recieveSubmitEmail:""

};

export function useUsers() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_USERS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...UserQueryConfig
    });
    return {...result, users: result.data};
}

export function useUser(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_USERS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...UserQueryConfig
    });
    return {...result, user: result.data};
}

export function useUserMutations() {
    async function createFunction(user) {
        if (!user) return;
        return await fetchPOST(BASE_URL, user, false);
    }

    async function editFunction(user) {
        if (!user) return;
        return await fetchPUT(`${BASE_URL}/${user.id}`, user);
    }

    async function editAddNewFiles(user) {
        if (!user) return;
        return await fetchPUT(`${BASE_URL}/${user.id}/files`, user.filesIds);
    }

    async function deleteFunction(user) {
        return await fetchDELETE(`${BASE_URL}/${user.id}`)
    }
    return {
        createUser: useMyMutation(createFunction, REACT_QUERY_ID_USERS, user => `User ${user.username} created`),
        editUser: useMyMutation(editFunction, REACT_QUERY_ID_USERS, user => `User ${user.username} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_USERS, user => `User ${user.username} modified`),
        deleteUser: useMyMutation(deleteFunction, REACT_QUERY_ID_USERS, user => `User ${user.username} deleted.`)
    };

}